import React, { useEffect, useState } from 'react';
import {
  Button,
  IconButton,
  InputAdornment,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from '@material-ui/core';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import {
  VENDOR_CREATE_LIGHT,
  VENDOR_CREATE_SCENE,
  VENDOR_CREATE_CURTAIN,
  VENDOR_CREATE_THERMO,
  VENDOR_CREATE_DDK,
  VENDOR_CREATE_DOOR_LOCK,
  VENDOR_CREATE_DOOR_CAMERA,
  VENDOR_CREATE_DND,
  VENDOR_CREATE_MMR,
  VENDOR_EDIT_LIGHT,
  VENDOR_EDIT_SCENE,
  VENDOR_EDIT_CURTAIN,
  VENDOR_EDIT_THERMO,
  VENDOR_EDIT_DDK,
  VENDOR_EDIT_DOOR_LOCK,
  VENDOR_EDIT_DOOR_CAMERA,
  VENDOR_EDIT_DND,
  VENDOR_EDIT_MMR,
  VENDOR_TAB_LIGHT,
  VENDOR_TAB_SCENE,
  VENDOR_TAB_CURTAIN,
  VENDOR_TAB_THERMO,
  VENDOR_TAB_DDK,
  VENDOR_TAB_DOOR_LOCK,
  VENDOR_TAB_DOOR_CAMERA,
  VENDOR_TAB_DND,
  VENDOR_TAB_MMR,
  VENDOR_VIEW_LIGHT,
  VENDOR_VIEW_SCENE,
  VENDOR_VIEW_CURTAIN,
  VENDOR_VIEW_THERMO,
  VENDOR_VIEW_DDK,
  VENDOR_VIEW_DOOR_LOCK,
  VENDOR_VIEW_DOOR_CAMERA,
  VENDOR_VIEW_DND,
  VENDOR_VIEW_MMR,
} from '../../../../../constants/VendorConst';
import { deleteExisitingVendor } from '../../../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import { AddCircle, MoreHoriz } from '@material-ui/icons';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import CreateIcon from '@material-ui/icons/Create';
import './VendorList.scss';
import DuplicateVendorPopup from '../../../../../components/duplicate-vendor-popup/Duplicate-Vendor-Popup';
import { greTemplatesSelector } from '../../../configurationSlice';
import { useSelector } from 'react-redux';
import WarningPopup from '../../../../../shared/warning-popup/Warning-Popup';

const initialState = {
  selectedValue: {
    id: '',
    title: '',
    name: '',
    description: '',
    enabledAttributes: [],
    status: false,
    warn: false,
    duplicate: false,
    createdAt: '',
    updatedAt: '',
    anchorEl: null,
    vendorItem: null,
  },
};

const VendorList = (props) => {
  const originalTemplates = useSelector(greTemplatesSelector);
  const { type, onDrawerToggle, onViewToggle, vendorList, refreshVendors, hotelId } = props;
  const [vendors, setVendors] = useState([]);
  const [selectedValue, setSelectedValue] = useState(initialState.selectedValue);
  const [tempSearchText, setTempSearchText] = useState('');

  const onOpenDrawerCreate = (type) => {
    onDrawerToggle(type, true, null);
  };

  const onOpenDrawerEdit = (type) => {
    onDrawerToggle(type, true, selectedValue);
    setSelectedValue((prev) => ({
      ...prev,
      anchorEl: null,
    }));
  };

  const onOpenDrawer = (event, type) => {
    event?.stopPropagation();
    onOpenDrawerCreate(type);
  };

  const handleCellMenuClick = (e, item) => {
    setSelectedValue((prev) => ({
      ...prev,
      id: item?.id,
      name: item?.name,
      type: item?.type,
      enabledAttributes: item?.enabledAttributes,
      createdAt: 'test',
      updatedAt: 'test',
      anchorEl: e.currentTarget,
      vendorItem: item,
      warningPopup: {
        name: item?.name,
      },
    }));
  };

  const handleRevertState = () => {
    setSelectedValue(initialState?.selectedValue);
  };

  const handleDeleteFlag = (e, item) => {
    if (isVendorUsed()) {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Delete Error',
        description: 'You can not delete an assigned vendor',
        warn: true,
        status: false,
        anchorEl: null,
      }));
    } else {
      setSelectedValue((prev) => ({
        ...prev,
        title: 'Are you sure you want to delete',
        description:
          'This action cannot be reversed. Properties associated with this Vendor will be reassigned.',
        status: true,
        warn: false,
        anchorEl: null,
      }));
    }
  };

  const onDeleteVendor = (hotelIdIn, vendorIdIn) => {
    deleteExisitingVendor(hotelIdIn, vendorIdIn)
      .then((res) => {
        notificationManager('success', 'Vendor deleted successfully');
        refreshVendors();
        handleRevertState();
      })
      .catch((e) => {
        notificationManager('danger', 'Error in deleting vendor');
      });
  };

  const onDuplicateVendor = () => {
    setSelectedValue((prev) => ({
      ...prev,
      duplicate: true,
    }));
  };

  const selectVendorType = (action, type) => {
    switch (type) {
      case VENDOR_TAB_LIGHT:
        return action === 'CREATE' ? VENDOR_CREATE_LIGHT : VENDOR_EDIT_LIGHT;
      case VENDOR_TAB_SCENE:
        return action === 'CREATE' ? VENDOR_CREATE_SCENE : VENDOR_EDIT_SCENE;
      case VENDOR_TAB_THERMO:
        return action === 'CREATE' ? VENDOR_CREATE_THERMO : VENDOR_EDIT_THERMO;
      case VENDOR_TAB_CURTAIN:
        return action === 'CREATE' ? VENDOR_CREATE_CURTAIN : VENDOR_EDIT_CURTAIN;
      case VENDOR_TAB_DDK:
        return action === 'CREATE' ? VENDOR_CREATE_DDK : VENDOR_EDIT_DDK;
      case VENDOR_TAB_DOOR_LOCK:
        return action === 'CREATE' ? VENDOR_CREATE_DOOR_LOCK : VENDOR_EDIT_DOOR_LOCK;
      case VENDOR_TAB_DOOR_CAMERA:
        return action === 'CREATE' ? VENDOR_CREATE_DOOR_CAMERA : VENDOR_EDIT_DOOR_CAMERA;
      case VENDOR_TAB_DND:
        return action === 'CREATE' ? VENDOR_CREATE_DND : VENDOR_EDIT_DND;
      case VENDOR_TAB_MMR:
        return action === 'CREATE' ? VENDOR_CREATE_MMR : VENDOR_EDIT_MMR;
      default:
        break;
    }
  };

  const isVendorUsed = () => {
    switch (props.type) {
      case VENDOR_TAB_LIGHT:
        return originalTemplates?.find((vendor) => vendor?.lightsVendor?.id === selectedValue?.id);
      case VENDOR_TAB_SCENE:
        return originalTemplates?.find((vendor) => vendor?.scenesVendor?.id === selectedValue?.id);
      case VENDOR_TAB_THERMO:
        return originalTemplates?.find(
          (vendor) => vendor?.thermostatVendor?.id === selectedValue?.id,
        );
      case VENDOR_TAB_CURTAIN:
        return originalTemplates?.find(
          (vendor) => vendor?.curtainsVendor?.id === selectedValue?.id,
        );
      case VENDOR_TAB_DOOR_LOCK:
        return originalTemplates?.find(
          (vendor) => vendor?.doorLockVendor?.id === selectedValue?.id,
        );
      default:
        break;
    }
  };

  const onViewDetails = (data, e) => {
    let selectedClassname = e.target.className;
    if (selectedClassname === 'MuiTableCell-root MuiTableCell-body') {
      openViewTab(data);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue?.vendorItem) {
      openViewTab(selectedValue?.vendorItem);
    }
  };

  const openViewTab = (data) => {
    switch (type) {
      case VENDOR_TAB_LIGHT:
        return onViewToggle(VENDOR_VIEW_LIGHT, true, data);
      case VENDOR_TAB_SCENE:
        return onViewToggle(VENDOR_VIEW_SCENE, true, data);
      case VENDOR_TAB_THERMO:
        return onViewToggle(VENDOR_VIEW_THERMO, true, data);
      case VENDOR_TAB_CURTAIN:
        return onViewToggle(VENDOR_VIEW_CURTAIN, true, data);
      case VENDOR_TAB_DDK:
        return onViewToggle(VENDOR_VIEW_DDK, true, data);
      case VENDOR_TAB_DOOR_LOCK:
        return onViewToggle(VENDOR_VIEW_DOOR_LOCK, true, data);
      case VENDOR_TAB_DOOR_CAMERA:
        return onViewToggle(VENDOR_VIEW_DOOR_CAMERA, true, data);
      case VENDOR_TAB_DND:
        return onViewToggle(VENDOR_VIEW_DND, true, data);
      case VENDOR_TAB_MMR:
        return onViewToggle(VENDOR_VIEW_MMR, true, data);
      default:
        break;
    }
  };

  const handleSearchText = (keyword) => {
    setTempSearchText(keyword);
    const vendorsCopy = [...vendorList];
    const temporaryList = vendorsCopy?.filter((data) =>
      data?.name?.toLowerCase()?.includes(keyword?.toLowerCase()),
    );
    setVendors(keyword !== '' ? [...temporaryList] : vendorList);
  };

  useEffect(() => {
    vendorList && setVendors(vendorList);
    setTempSearchText('');
  }, [vendorList]);

  return (
    <div className='mt-4 mb-4 vendor-list-container'>
      {selectedValue?.id && selectedValue?.duplicate && (
        <DuplicateVendorPopup
          currentHotelId={hotelId}
          onDuplicateClose={handleRevertState}
          duplicatePopup={selectedValue}
          refreshVendors={refreshVendors}
        />
      )}
      {selectedValue?.id && selectedValue?.status && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDeleteCancel={handleRevertState}
          onDelete={(e) => onDeleteVendor(hotelId, selectedValue?.id)}
        />
      )}
      {selectedValue?.warn && (
        <WarningPopup
          warningPopup={selectedValue?.warningPopup}
          warn={selectedValue?.warn}
          onWarningClose={() =>
            setSelectedValue((prev) => ({
              ...prev,
              warn: false,
              anchorEl: null,
            }))
          }
        />
      )}
      <SearchBar
        setSearchText={handleSearchText}
        onOpenDrawer={onOpenDrawer}
        buttonName='Add Vendor'
        type={selectVendorType('CREATE', type)}
        searchText={tempSearchText}
        displayAddOrEdit='show'
        actionMenuItems={[]}
      />
      <div className='row mx-2 d-flex mt-3'>
        <TableContainer>
          <Table className='list-table' aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell className='w-90'>Vendor Name</TableCell>
                <TableCell className='w-10'></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {vendors?.map((item, index) => (
                <TableRow
                  key={index}
                  className='border-white pointer'
                  onClick={(e) => onViewDetails(item, e)}
                >
                  <TableCell>{item?.name}</TableCell>
                  <TableCell align='right'>
                    <Button
                      aria-controls='simple-menu'
                      aria-haspopup='true'
                      onClick={(e) => {
                        handleCellMenuClick(e, item);
                      }}
                    >
                      <MoreHoriz />
                    </Button>
                    <Menu
                      id={index}
                      keepMounted
                      anchorEl={selectedValue?.anchorEl}
                      disableRestoreFocus
                      MenuListProps={{ autoFocusItem: false }}
                      className='shadow'
                      onClose={(e) => handleRevertState()}
                      open={Boolean(selectedValue.anchorEl) && selectedValue?.id === item?.id}
                    >
                      <MenuItem
                        className='pe-4'
                        onClick={() => {
                          onOpenDrawerEdit(selectVendorType('EDIT', type));
                        }}
                      >
                        <CreateIcon className='me-2 action-menu-icon' />
                        Edit
                      </MenuItem>
                      <MenuItem
                        className='pe-4 vendor-view'
                        onClick={(e) => {
                          onClickView(e);
                        }}
                      >
                        <VisibilityIcon className='me-2 action-menu-icon' />
                        View
                      </MenuItem>
                      <MenuItem
                        className='pe-4'
                        onClick={(e) => {
                          handleDeleteFlag();
                        }}
                      >
                        <DeleteForeverIcon className='me-2 action-menu-icon' />
                        Delete
                      </MenuItem>
                      <MenuItem
                        className='pe-4'
                        onClick={() => {
                          onDuplicateVendor(selectedValue?.id);
                        }}
                      >
                        <ContentCopyIcon className='me-2 action-menu-icon' />
                        Duplicate
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default VendorList;
